<template>
  <ul class="list-none flex gap-0.5 flex-1 justify-end">
    <li v-if="isEntityOwner && project && !project?.download_expired">
      <u-tooltip text="Share">
        <core-selection-toolbar-button
          dark
          size="lg"
          :icon="COMMON_ICONS.share"
          @click="digiActions.shareFile({file})"
          data-gtmid="core_ui-digi-file_share"
        />
      </u-tooltip>
    </li>

    <li v-show="isZoomable" class="hidden sm:block">
      <u-tooltip text="Zoom">
        <core-selection-toolbar-button
          dark
          size="lg"
          :icon="isZoomed ? 'i-ri-zoom-out-line' : 'i-ri-zoom-in-line'"
          @click="zoom()"
        />
      </u-tooltip>
    </li>

    <li>
      <u-tooltip text="Use as Project Cover" v-if="isEntityOwner && project && !project.download_expired">
        <core-selection-toolbar-button
          dark
          size="lg"
          :icon="COMMON_ICONS.makeCover"
          @click="digiActions.makeCover({file, projectId})"
        />
      </u-tooltip>
    </li>

    <li>
      <u-tooltip :text="isPanelVisible ? 'Hide Info' : 'Show Info'">
        <core-selection-toolbar-button
          dark
          size="lg"
          icon="i-ri-information-2-line"
          @click="emit('toggle-panel', true)"
        />
      </u-tooltip>
    </li>
  </ul>
</template>

<script setup>
  const emit = defineEmits(['toggle-panel'])
  const props = defineProps({
    isPanelVisible: Boolean,
    isDownloadPending: Boolean
  });

  const digiActions = useDigitizationActions();
  const filesStore = useFilesStore();
  const sessionStore = useSessionStore();
  const digitizationStore = useDigitizationStore();
  const {project} = storeToRefs(digitizationStore);
  const {file} = storeToRefs(filesStore);
  const {currentUserId} = storeToRefs(sessionStore);

  const projectId = useRoute().params.box_id;
  const isEntityOwner = computed(() => file.value?.user?.id === currentUserId.value);

  const setDefaultZoomEvent = useEventBus('file-detail-set-default-zoom');
  const updateZoomEvent = useEventBus('file-detail-update-zoom');
  const isZoomable = computed(() => !(file.value.is.video || file.value.is.audio));
  const isZoomed = ref(false);
  function zoom() {
    setDefaultZoomEvent.emit({file: file.value, action: isZoomed.value ? 'zoom-out' : 'zoom-in'})
  }

  function updateZoomState({isZoomed: updatedZoomState}) {
    isZoomed.value = updatedZoomState;
  }

  onMounted(() => {
    updateZoomEvent.on(updateZoomState);
  });

  onBeforeUnmount(() => {
    updateZoomEvent.off(updateZoomState);
  });
</script>
